export class StringValidacao {

    static copiarStringValida(valor: string): string {
        if (valor !== null && valor !== undefined && valor.trim() !== '' && valor.length > 0) {
            return valor.slice(0);
        }
        return undefined;
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/string.ts